// extracted by mini-css-extract-plugin
export default {"contactItem":"ContactItem_contactItem__6DdVK","contactStyle":"ContactItem_contactStyle__Af4In"};